import APIService from '@/services/APIService';
import APIDadataService from '@/services/APIDadataService';

import Contracts from '@/models/list/Contracts';

export default {
  getTypicalContract(params) {
    return APIService.get('/typical-contracts', params);
  },
  saveTypicalContract(params) {
    return APIService.post('/typical-contracts', params);
  },
  updateTypicalContract(params, id) {
    return APIService.put(`/typical-contracts/${id}`, params);
  },
  deleteTypicalContract(id) {
    return APIService.delete(`/typical-contracts/${id}`);
  },

  getPayment(id) {
    return APIService.get(`/organizations/${id}`);
  },
  createContracts(params, query) {
    return APIService.post('/contracts?expand=preview_document', params, query);
  },
  updateContracts(params, query) {
    return APIService.put(`/contracts/${params.id}`, params, query);
  },
  updateContractsUsers(id, params, query) {
    return APIService.put(`/contracts/${id}/users`, params, query);
  },
  getContracts(params) {
    return APIService.get('/contracts', { params });
  },
  getContract(id, params) {
    return APIService.get(`/contracts/${id}`, { params, rOptions: { model: Contracts } });
  },
  getContractNoModel(id, params) {
    return APIService.get(`/contracts/${id}`, { params });
  },
  getContractsModel(params) {
    return APIService.get('/contracts', { params, rOptions: { model: Contracts, many: true } });
  },
  setContractDiscount(id, params) {
    return APIService.put(`/contracts/${id}/discount`, params);
  },
  cancelContract(id) {
    return APIService.post(`/contracts/${id}/terminate`);
  },

  getDadataOrg(params) {
    return APIDadataService.post('/findById/party', params);
  },
  getDadataBic(params) {
    return APIDadataService.post('/suggest/bank', params);
  },

  updatePaymentDetail(id, params) {
    return APIService.put(`organizations/${id}/payment-detail`, params);
  },
  getPDF(id, params) {
    return APIService.get(`/contracts/${id}/payment-invoice-pdf`, { params, responseType: 'blob' });
  },
  setPayment(params) {
    return APIService.post('/transactions', params);
  },
  getTransactions(params) {
    return APIService.get('/transactions', { params });
  },
  getQR(id, params) {
    return APIService.get(`/contracts/${id}/qrcode`, { params });
  },

  getDiscounts(params) {
    return APIService.get('/typical-contract-discounts', params);
  },
  createDiscount(params) {
    return APIService.post('/typical-contract-discounts', params);
  },
  updateDiscounts(id, params) {
    return APIService.put(`/typical-contract-discounts/${id}`, params);
  },

  viewContract(id) {
    return APIService.post(`/contracts/${id}/view`);
  },

  startPaymentWithQr(id, payload, params) {
    return APIService.post(`contracts/${id}/tinkoff/spb-payment`, payload, params);
  },
  successPayment(params) {
    return APIService.get('payments/tinkoff/success', { params });
  },
  failPayment(params) {
    return APIService.get('payments/tinkoff/fail', { params });
  },
  getPayments(params) {
    return APIService.get('/payments', params);
  },

  getAgreements(params) {
    return APIService.get('/agreements', { params });
  },
  getAgreement(id, params) {
    return APIService.get(`/agreements/${id}`, { params });
  },
  createAgreement(params) {
    return APIService.post('/agreements/', params);
  },
  saveAgreement(id, params) {
    return APIService.put(`/agreements/${id}`, params);
  },
  deleteAgreement(id) {
    return APIService.delete(`/agreements/${id}`);
  },
  signDocument(id, payload, params) {
    return APIService.post(`/contracts/${id}/sign-document`, payload, params);
  },
  signAct(id, payload, params) {
    return APIService.post(`/contracts/${id}/sign-act`, payload, params);
  },
  getSignDocumentsContract(contractId, params) {
    return APIService.get(`contracts/${contractId}/download/signatures`, { params });
  },
  getSignDocumentsAct(contractId, params) {
    return APIService.get(`contracts/${contractId}/download/act/signatures`, { params });
  },
  getSignature(contractId, id, params) {
    return APIService.get(`contracts/${contractId}/download/signatures/${id}`, { params });
  },
  getPrintVersionContract(contractId, params) {
    return APIService.get(`contracts/${contractId}/download/print-version`, { params, responseType: 'blob' });
  },
  getPrintVersionAct(contractId, params) {
    return APIService.get(`contracts/${contractId}/download/act/print-version`, { params, responseType: 'blob' });
  },

  getRoomContract(id, payload) {
    return APIService.post(`contracts/${id}/chat-room`, payload);
  },

  getAgreementUnreadMessages() {
    return APIService.get('/contracts/typical-contracts/exists-unread-messages');
  },
  getEnrollmentUnreadMessages() {
    return APIService.get('/contracts/contract/exists-unread-messages');
  },
  generateAct(id) {
    return APIService.get(`contracts/${id}/download/act`, { responseType: 'blob' });
  },

};
